import { z } from "zod";
import { statusPageVisibilitySchema, uuidSchema } from "./common";

const slugPattern = /^[a-z0-9-]+$/;

/** `POST /v1/status-pages` body. Mirrors `CreatePage` in routes_ops.rs. */
export const createStatusPageSchema = z.object({
  slug: z
    .string()
    .trim()
    .toLowerCase()
    .min(3, "slug must be at least 3 characters")
    .regex(slugPattern, "slug must be lowercase alphanumeric/hyphen"),
  title: z.string().trim().min(1, "title is required").max(200),
  visibility: statusPageVisibilitySchema,
  service_groups: z
    .array(z.object({ name: z.string().trim().min(1), asset_ids: z.array(uuidSchema) }))
    .default([]),
});
export type CreateStatusPageInput = z.infer<typeof createStatusPageSchema>;

export const publishStatusPageSchema = z.object({ published: z.boolean() });
export type PublishStatusPageInput = z.infer<typeof publishStatusPageSchema>;

export const publishIncidentToPageSchema = z.object({
  public_note: z.string().trim().max(2000).optional().or(z.literal("")),
});
export type PublishIncidentToPageInput = z.infer<typeof publishIncidentToPageSchema>;
